export enum RegionType {
  USA = 'us-east-1',
  AUS = 'ap-southeast-2',
}
